import { DropDownMenu } from '@app/ui/dropdown-menu/DropDownMenu'
import RoundedButton from '@app/ui/rounded-button/RoundedButton'
import moment from 'moment'
import React, { FunctionComponent, useEffect, useState, useRef } from 'react'
import { useMediaQuery } from 'react-responsive'

import { ProjectCourse, ProjectHole } from '../../../types/Project'
import HoleButton from '../../atoms/HoleButton'
import Spacer from '../../atoms/Spacer'
import * as S from './styled'
import { useRatingTemplate } from '../../../pages/CreateRatingTemplatePage/tabs/SelectHoles/hooks/useRatingTemplate'

type Props = {
  courses: ProjectCourse[]
  selectedCourse: ProjectCourse | undefined
  handleDropdownChange: (course: ProjectCourse) => void
  handleHolePress: (
    hole: ProjectHole,
    courseName: string,
    courseId: string,
    holeIsSelected: boolean
  ) => void
  selectedHoles: ProjectHole[]
  rateCoursePress: () => void
}

const HoleSelectorThree: FunctionComponent<Props> = ({
  courses,
  selectedCourse,
  handleDropdownChange,
  handleHolePress,
  rateCoursePress,
  selectedHoles,
}) => {
  const { setRatingHoleData, ratingHoles } = useRatingTemplate()
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1524px)' })
  const overlayRef = useRef() as React.MutableRefObject<HTMLDivElement>

  const correctedHoleNumber = (hole: ProjectHole) => +hole.courseHoleNumber - 1

  return (
    <S.OuterContainer>
      <S.HeaderContainer>
        <Spacer height={16} />
        <S.HeaderText>Select holes</S.HeaderText>
        <Spacer height={16} />
      </S.HeaderContainer>
      <div>
        <Spacer height={16} />
        <S.MiddleContainer>
          <div>
            <S.SelectorText>Course selector</S.SelectorText>
            <Spacer height={8} />
            <RoundedButton
              title="Include this course"
              onPress={rateCoursePress}
            />
          </div>
        </S.MiddleContainer>
        <Spacer height={16} />
        <S.MiddleContainer>
          <DropDownMenu
            width={390}
            tablet={isTabletOrMobile}
            value={selectedCourse?.name}
            reference={overlayRef}
            relative
          >
            {courses.map((course) => (
              <div
                key={course.id}
                onClick={() => {
                  handleDropdownChange(course)
                  if (overlayRef?.current) {
                    overlayRef.current.click()
                  }
                }}
                style={{
                  padding: '8px 16px',
                  cursor: 'pointer',
                  borderBottom: '1px solid #CECECE',
                }}
              >
                {course.name} - {course.holeCount} holes
              </div>
            ))}
          </DropDownMenu>
        </S.MiddleContainer>
        <Spacer height={16} />
        {selectedCourse && (
          <S.ContentContainer>
            {selectedCourse.holes.map((hole, index) => {
              const holeIsSelected = selectedHoles.some(
                (ratingHole) => ratingHole.physicalID === hole.physicalID
              )

              return (
                <S.HoleContainer
                  key={hole.physicalID}
                  style={{ marginBottom: 24 }}
                >
                  <HoleButton
                    key={hole.courseHoleNumber}
                    holeNr={correctedHoleNumber(hole) + 1}
                    ghNr={+hole.globalHoleNumber}
                    selected={!!holeIsSelected}
                    par={+hole.par}
                    onPress={() => {
                      setRatingHoleData({
                        courseName: selectedCourse.name,
                        courseHoleNumber: +hole.courseHoleNumber,
                        id: hole.physicalID,
                        par: +hole.par,
                      })
                      handleHolePress(
                        hole,
                        selectedCourse.name,
                        selectedCourse.id,
                        !!holeIsSelected
                      )
                    }}
                  />
                </S.HoleContainer>
              )
            })}
          </S.ContentContainer>
        )}
      </div>
      {!isTabletOrMobile && <Spacer height={32} />}
    </S.OuterContainer>
  )
}

export default HoleSelectorThree
